// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles-module__subtitle___2QxLi","talk-charts":"styles-module__talk-charts___2SbKs"};